/** Cash Out program — combined withdrawal from box + step-4 cash wallet. */

export const CASH_OUT_WITHDRAWAL_MIN = 150;
export const CASH_OUT_WITHDRAWAL_STEP = 150;

/** @deprecated use combined helpers below */
export const CASH_OUT_CASH_WALLET_MIN_WITHDRAWAL = 750;
export const CASH_OUT_CASH_WALLET_WITHDRAWAL_STEP = 750;

export function getTotalCashOutAvailable(cashOutBox, cashOutCashWallet) {
  const box = Number(cashOutBox?.available) || 0;
  const cash = Number(cashOutCashWallet?.available) || 0;
  return box + cash;
}

export function roundDownToWithdrawalStep(balance) {
  const b = Number(balance) || 0;
  const step = CASH_OUT_WITHDRAWAL_STEP;
  if (b < CASH_OUT_WITHDRAWAL_MIN) return 0;
  return Math.floor(b / step) * step;
}

export function maxCashOutWithdrawalRequest(cashOutBox, cashOutCashWallet) {
  return roundDownToWithdrawalStep(
    getTotalCashOutAvailable(cashOutBox, cashOutCashWallet)
  );
}

export function validateCashOutCashWalletWithdrawalAmount(
  amount,
  cashOutBox,
  cashOutCashWallet
) {
  const amt = Number(amount);
  const max = maxCashOutWithdrawalRequest(cashOutBox, cashOutCashWallet);

  if (amt < CASH_OUT_WITHDRAWAL_MIN) {
    return {
      ok: false,
      message: `Minimum withdrawal is ₹${CASH_OUT_WITHDRAWAL_MIN}`,
    };
  }
  if (amt % CASH_OUT_WITHDRAWAL_STEP !== 0) {
    return {
      ok: false,
      message: `Amount must be in multiples of ₹${CASH_OUT_WITHDRAWAL_STEP}`,
    };
  }
  if (amt > max) {
    return {
      ok: false,
      message: `Maximum you can request is ₹${max}`,
    };
  }
  return { ok: true, max };
}
